import { useEffect } from 'react';

import { useFormikContext } from 'formik';

import { resetEditMode, toggleAllEditMode } from '../../store/editMode';
import { setErrorFields } from '../../store/fieldError';

function validateForm(dispatch, submitForm, validated, setValidation) {
  // This promise toggles all cards into edit mode, then validates to get the erros and adds them to the fieldError store, and finally closes all edit mode
  return new Promise(res => {
    if (!validated) {
      // Toggle edit mode for all cards
      dispatch(toggleAllEditMode());
    }
    res();
  }).then(() => {
    if (!validated) {
      // Submit form to get errors
      submitForm().then(() => {
        // Close all edit modes
        dispatch(resetEditMode());
        // Sets review inital validation as completed
        setValidation(true);
      });
    }
  });
}

function AutoValidation({ dispatch, setValidation, validated }) {
  // Get the submitForm method and all errors from formik.form
  const { submitForm, errors = {} } = useFormikContext();
  useEffect(() => {
    dispatch(setErrorFields(errors));
  }, [dispatch, errors]);

  useEffect(() => {
    // On load, run inital validation
    validateForm(dispatch, submitForm, validated, setValidation);
  }, [submitForm, dispatch, errors, validated, setValidation]);

  return null;
}

export default AutoValidation;
